import styles from "./PolicyEmpty.module.css";

export default function PolicyEmpty(): JSX.Element {
  return (
    <div className={styles.container}>
      <div className={styles.text}>No content available.</div>
    </div>
  );
}
